export enum OrderStatusEnum {
  INITIALIZED = 0,
  PENDING = 1,
  CONFIRMED = 2,
  PICKING_UP = 3,
  IN_PROGRESS = 4,
  DELIVERING = 5,
  FINISHED = 6,
  FAILED = 7,
  CANCELLED_BY_CAFLER = 10,
  CANCELLED_BY_CLIENT = 11,
  CANCELLED = 12,
}

const PREFIX = 'common.service_status.';

export const OrderStatusLabel: Record<OrderStatusEnum, string> = {
  [OrderStatusEnum.INITIALIZED]: `${PREFIX}INITIALIZED`,
  [OrderStatusEnum.PENDING]: `${PREFIX}PENDING`,
  [OrderStatusEnum.CONFIRMED]: `${PREFIX}CONFIRMED`,
  [OrderStatusEnum.PICKING_UP]: `${PREFIX}PICKING_UP`,
  [OrderStatusEnum.IN_PROGRESS]: `${PREFIX}IN_PROGRESS`,
  [OrderStatusEnum.DELIVERING]: `${PREFIX}DELIVERING`,
  [OrderStatusEnum.FINISHED]: `${PREFIX}FINISHED`,
  [OrderStatusEnum.FAILED]: `${PREFIX}FAILED`,
  [OrderStatusEnum.CANCELLED_BY_CAFLER]: `${PREFIX}CANCELLED_BY_CAFLER`,
  [OrderStatusEnum.CANCELLED_BY_CLIENT]: `${PREFIX}CANCELLED_BY_CLIENT`,
  [OrderStatusEnum.CANCELLED]: `${PREFIX}CANCELLED`,
};